import React from 'react'
import './ProfileIcon.css'

function ProfileIcon(props) {
    const upperCaseFirstCharacter = props.firstCharacter?.toUpperCase() || '';
  return (
    <>
        <div className='profile-sty'>
            <span className={`fontBold font-size05 colorGray03 ${
                        props.className
            }`}>{upperCaseFirstCharacter}</span>
        </div>
    </>
  )
}

export default ProfileIcon;